import type { RouteRecordRaw } from 'vue-router'
import { assertThat } from '../Guards'
import { Routes } from '../../Constants/Routes.ts'
import RedirectToLegacyPage from '../../Views/RedirectToLegacyPage.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/contrats',
    meta: {
      guards: assertThat().authenticated(),
    },
    children: [
      {
        name: Routes.CONTRACT_VIEW,
        path: ':id(\\d+)',
        component: RedirectToLegacyPage,
        props: (route) => ({ id: Number(route.params.id) }),
        meta: {
          target: '/contrats/contract.php?i={id}',
        },
      },
    ],
  },
]

export default routes
